/**
 * "Please call us directly."
 *
 * Shown at the two moments the online form genuinely cannot finish the job:
 * a party of twelve or more, and a booking for today. Both need a human — a
 * large party has to be built out of tables someone is looking at, and a
 * same-day request depends on what has walked in this evening.
 *
 * Deliberately placed AT those moments rather than in the footer. A guest who
 * has already chosen a date and typed their name, only to be told at the end
 * to phone instead, has been wasted; a note in a footer is not read by anyone
 * who is not already looking for it.
 */

import { useTranslation } from 'react-i18next';

/** The reservations line, matching the footer. */
const PHONE = { tel: '+97444111502', label: '+974 4411 1502' } as const;

export function CallUsNotice({ reason }: { reason: 'largeParty' | 'sameDay' }) {
  const { t } = useTranslation();
  return (
    <p className="rounded-lg border border-brand-gold bg-brand-gold-light px-3 py-2.5 text-sm text-brand-ink">
      {t(`widget.call_${reason}`)}{' '}
      <a
        href={`tel:${PHONE.tel}`}
        dir="ltr"
        className="font-medium text-brand-teal underline underline-offset-2 hover:text-brand-teal-dark"
      >
        {PHONE.label}
      </a>
    </p>
  );
}
